import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const token = localStorage.getItem("user");
  return !token ? <Outlet /> : <Navigate to="/dashboard" />;
};

export default PublicRoute;